import React from "react";
import MenuGroup from "~/components/AppBar/MenuGroup";
import { Box, Avatar } from "~/native-ui";

const UserAvatar = ({ userMeta }) => {
    const source = userMeta.avatar_url ? { uri: userMeta.avatar_url } : null
    
    return (
        <Box mx="1">
            <Avatar size="sm" bg="primary.600" source={source}>
                {userMeta.name?.[0]?.toUpperCase()}
            </Avatar>
        </Box>
    )
}

export default (props) => {
    let { menu, userMeta, ...rest } = props,
        menuRef = React.useRef(menu).current,
        userMenu = React.useMemo(() => [{
            icon: <UserAvatar userMeta={userMeta} />,
            label: userMeta.name,
            children: menuRef
        }], [menuRef, userMeta]);

    return <MenuGroup { ...rest } menu={userMenu} />
}